module.exports = __webpack_public_path__ + "img/inc42-sticky-logo.56551764.svg";